var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classObject,style:(_vm.customStyle)},[_vm._t("default"),(_vm.dismissible)?_c('div',{class:_vm.$style.btn_wrapper,on:{"click":_vm.toggle}},[_c('base-icon',{attrs:{"name":"times","size":"8px"}})],1):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }